import React from 'react'
import ContentLayout from '../../components/ContentLayout/ContentLayout'
import MainHeading from '../../components/MainHeading/MainHeading'
import CardInfo from '../../components/CardInfo/CardInfo'
import clsx from 'clsx'

const browsers = [
    {
        first: true,
        last: false,
        name: 'Google Chrome',
        link: 'https://www.google.com/intl/us-419/chrome/',
    },
    {
        first: false,
        last: false,
        name: 'Mozilla Firefox',
        link: 'https://www.mozilla.org/en-US/firefox/new/',
    },
    {
        first: false,
        last: false,
        name: 'Microsoft Edge',
        link: 'https://www.microsoft.com/en-us/edge',
    },
    {
        first: false,
        last: true,
        name: 'Safari',
        link: 'https://support.apple.com/downloads/safari',
    },
]

const SupportedBrowsersPage = () => {
    const renderList = () => {
        return (
            <div className="w-full h-auto">
                <ul role="list" className="divide-y divide-gray-200">
                    {browsers.map(browser => (
                        <li
                            key={browser.name}
                            className={clsx(
                                browser.first
                                    ? 'pb-4'
                                    : browser.last
                                    ? 'pt-4'
                                    : 'py-4',
                            )}
                        >
                            <a
                                className="text-links hover:underline"
                                href={browser.link}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {browser.name}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        )
    }

    return (
        <ContentLayout>
            <MainHeading title="Supported Browsers" />
            <div className="lg:w-220 w-full lg:my-8 h-auto flex flex-col items-center justify-center relative gap-4">
                <div className="w-full h-auto lg:p-0 lg:pb-0 p-4 pb-0">
                    <CardInfo
                        hasPaddingContent
                        title="List of LiftOne Now supported browsers"
                        content={renderList()}
                    />
                </div>
            </div>
        </ContentLayout>
    )
}

export default SupportedBrowsersPage
